import { Badge } from 'src/components/atoms/Badge';
import styled from 'styled-components';

export const ReportImage = styled.img<{ small?: boolean }>`
  margin: 20px 0px 20px 20px;
  height: ${(props) => (props.small ? '65px' : '80px')};

  @media screen and (min-width: 0px) and (max-width: 480px) {
    height: 65px;
  }
`;

export const Top = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 20px;
  width: calc(100% - 40px);

  @media screen and (min-width: 0px) and (max-width: 480px) {
    padding-left: 10px;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;

export const HeaderRow = styled(Row)`
  justify-content: flex-start;
  align-items: center;
  gap: 10px;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    align-items: center;
    justify-content: space-between;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  width: 50%;
  height: 100%;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px;
  gap: 20px;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
    max-width: none;
  }
`;

export const ReportDetailColumn = styled(Column)<{ fullWidth?: boolean }>`
  ${(props) => props.fullWidth && 'width: 100%;'}
  align-items: flex-start;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    width: 100%;
  }
`;

export const ReportDetail = styled.p`
  ${(props) => props.theme.newTypography.textStyleBodySmall}
  color: ${(props) => props.theme.newPalette.neutral.N600};
  margin: 0;
`;

export const BoldHeader = styled.span`
  color: ${(props) => props.theme.newPalette.neutral.N800};
  ${(props) => props.theme.newTypography.textStyleBodySmallSemibold}
`;

export const StyledBadge = styled(Badge)<{ hideWhenBig?: boolean }>`
  margin-bottom: 12px;
  display: ${(props) => (props.hideWhenBig ? 'none' : 'flex')};
`;

export const SubmissionType = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodyLargeSemibold}
  margin-top: 0px;
  margin-bottom: 10px;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    ${(props) => props.theme.newTypography.textStyleBodySemibold}
  }
`;
